/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'minimal' }, { id: 'quick' }, { id: 'invest' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-women-styling-effort"
      progress={51}
      field="hairstyleWomenStylingEffort"
      setter="setHairstyleWomenStylingEffort"
      ns="hairstyleWomenStylingEffort"
      imageName="hairstyleWomenStylingEffort"
      options={OPTIONS}
    />
  );
}

export default Page;
